import React, { Component } from 'react';
// import './App.less';


import RouteConfig from "./configs/RouteConfig";

class App extends Component {
  render() {
    return (
      <RouteConfig/>
    );
  }
}

export default App;
